import request from '@/api/request'

const url_role_list = "/api/manager/role/list";
const url_role_save = "/api/manager/role/save";
const url_role_edit_init = "/api/manager/role/edit/init";
const url_role_edit_save = "/api/manager/role/edit/save";
const url_role_all = "/api/manager/role/all";


export function saveApi(params) {

  let data = {
    name: params.name,
    pids: params.pids
  }

  return request({
    url: url_role_save,
    method: 'post',
    data
  })
}

export function initApi(params) {

  let data = {
    id: params.id
  }

  return request({
    url: url_role_edit_init,
    method: 'post',
    data
  })
}

export function updateApi(params) {

  let data = {
    id: params.id,
    content: params.content,
    pids: params.pids
  }

  return request({
    url: url_role_edit_save,
    method: 'post',
    data
  })
}

export function allApi() {

  let data = {
    id: ""
  }

  return request({
    url: url_role_all,
    method: 'post',
    data
  })
}